import {backendEndpoints} from "../../libs/backendEndpoints";
import {Field} from "formik";
import {BackendForm} from "../../components/forms";
import {Alert, Button, FormError, SuccessAnimation} from "fearless-common-ui";
import React from "react";

const question = 'What are you looking for?';
const answerId = 'answer-textarea';

/**
 * Renders a form that allows users to request a callback or submit a question.
 *
 * The component displays a success animation and message upon successful form submission.
 * If not yet submitted, it displays an input form for users to provide their email and an answer to a question.
 *
 * @return Returns a JSX element representing either the submission success message or the input form.
 */
export default function CallMeBackForm(): JSX.Element {
  const [formSuccessful, setFormSuccessful] = React.useState<false | string>(false);

  if (formSuccessful) {
    return (
      <div className="text-center animated slideInDown">
        <SuccessAnimation />
        <Alert variant="success">{formSuccessful}</Alert>
      </div>
    );
  }

  return (
    <BackendForm
      initialValues={{
        email: '',
        question,
        answer: '',
      }}
      targetEndpoint={backendEndpoints.callMeBack}
      targetMethod="POST"
      showFooter={false}
      onSuccess={({ message }) => {
        setFormSuccessful(message);
      }}
    >
      <Field
        name="email"
        type="email"
        placeholder="Your e-mail"
        className="form-control form-control-lg bg-white shadow"
      />
      <span className="d-block text-danger mb-4">
        <FormError name="email" />
      </span>
      <label className="fw-semibold" htmlFor={answerId}>{question}</label>
      <Field
        name="answer"
        as="textarea"
        rows={7}
        id={answerId}
        placeholder="Please share your thoughts..."
        className="form-control form-control-lg bg-white mb-3 shadow"
      />
      <span className="d-block text-danger mb-4">
        <FormError name="answer" />
      </span>
      <BackendForm.Feedback showError />
      <div className="d-flex justify-content-center">
        <Button size="lg" type="submit" variant="success" className="py-3 text-lg fw-semibold px-5">
          Contact me
        </Button>
      </div>
    </BackendForm>
  );
}
